import { FeatureFlagType } from '../types/feature-flag-type.type';
import { ApplicationRoles } from './user-roles';

/**
 * Features that remain hidden from non-admin users even when their feature flag is enabled.
 *
 * The analytics pipeline designer is an internal (admin) tool: platform users consume its
 * outputs through the data catalogue and the API configuration module, but they never
 * author pipelines themselves.
 */
export const adminOnlyFeatures: FeatureFlagType[] = ['analytics'];

/** Roles allowed to access the features listed in {@link adminOnlyFeatures}. */
export const adminOnlyFeatureRoles = [ApplicationRoles.Admin];
